<script setup lang="ts">
import getMeta from "@/classes/getMeta";
import {CONTACTS} from "~/configs/contacts";
import {EVENTS} from "~/data/events";
import EventItem from "~/components/partials/EventItem.vue";
import EmptyEvents from "~/components/partials/EmptyEvents.vue";
import {isDone} from "~/functions/isDone";

definePageMeta({
  layout: "default",
  name: "index",
});

useHead(getMeta(
  `Конференции XSQUARE`,
  `Участие в конференциях позволяет экспертам оставаться в курсе актуальных трендов, новинок и достижений в своей области.`
));

useJsonld({
  "@context": "https://schema.org/",
  "@type": "Event",
  name: "Конференции XSQUARE",
  "url": "https://conf.xsquare.ru/",
  description: "Участие в конференциях позволяет экспертам оставаться в курсе актуальных трендов, новинок и достижений в своей области.",
  author: "Хи-квадрат",
  memoryRequirements: "512mb",
  startDate: "31/03/2025 12:00PM",
  endDate: "01/04/2025 02:00PM",
  publisher: {
    "@context": "https://schema.org",
    "@type": "Organization",
    "email": CONTACTS.email,
    "name": "Хи-квадрат",
    "telephone": CONTACTS.phone,
  }
})

const sortedEvents = {
  soon: {
    title: "Предстоящие мероприятия",
    events: EVENTS.filter(event => !isDone(event)),
    isDone: false,
  },
  done: {
    title: "Завершенные",
    events: EVENTS.filter(event => isDone(event)),
    isDone: true,
  },
}
</script>

<template>
<div class="page-index">
  <div class="page-index-header">
    <div class="container">
      <div class="page-index-grid">
        <div class="page-index-grid-row">
          <h1>Конференции XSQUARE</h1>
          <h2>Митапы, конференции и другие мероприятия платформы и партнёров</h2>
        </div>
        <div class="page-index-grid-row">
          <div class="page-index-grid-more-v2">
            <p class="s-1">
              XSQUARE 6.0 <br hide-xs>
              уже доступна на <span style="white-space: nowrap">демо-стенде</span>
            </p>
            <div class="buttons">
              <nuxt-link to="https://xsquare.ru/demo/" class="btn btn--fluid">ДЕМО 6.0</nuxt-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <client-only>
    <template
        v-for="(category, key, idx) in sortedEvents"
        :key="`cat_${key}`"
    >
      <div
          v-if="!!category?.events?.length || key !== 'done'"
          class="container events-list-wrapper"
      >
        <template v-if="!!category?.events?.length">
          <h3 :class="{ 'is-done': category.isDone }" class="events-list-title">
            {{ category?.title }}
          </h3>

          <ul class="events-list">
            <template
                v-for="(event, index) in category?.events"
                :key="`event_${index}_${event.dateStart}`"
            >
              <EventItem
                  :scheduled-event="event"
                  :is-done="category.isDone"
              />
            </template>
          </ul>
        </template>
        <EmptyEvents v-else-if="!category?.events?.length && key === 'soon'" />
      </div>
    </template>
  </client-only>
</div>

<sprites :use-current-color="false">
  <svg id="icon-video" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M20 11.5H3V20.5C3 21.0523 3.44772 21.5 4 21.5H20C20.5523 21.5 21 21.0523 21 20.5V12.5C21 11.9477 20.5523 11.5 20 11.5Z" stroke="currentcolor" stroke-linejoin="round"/>
    <path d="M1.59998 7.40002L17.5747 1.58568C18.0937 1.39679 18.6676 1.66438 18.8565 2.18335L19.5405 4.06274C19.7294 4.58172 19.4618 5.15556 18.9428 5.34445L2.96806 11.1588L1.59998 7.40002Z" stroke="currentcolor" stroke-linejoin="round"/>
    <path d="M15.6954 2.26973L15.1841 6.71254" stroke="currentcolor"/>
    <path d="M11.9366 3.6378L11.4253 8.08061" stroke="currentcolor"/>
    <path d="M8.17785 5.00589L7.66654 9.4487" stroke="currentcolor"/>
    <path d="M4.41906 6.37397L3.90775 10.8168" stroke="currentcolor"/>
  </svg>
</sprites>
</template>
